import { UnitConstants } from 'src/app/core/constants/unit';
import { ValidatorsTerms } from 'src/app/shared/validators/validators-terms';

const TERMS = ValidatorsTerms;

export class FlexLineUtilizationFactorFields {
  public static controls = {
    manufacturerType: {
      quantity: null,
      validator: TERMS.REQUIRED,
    },
    damagePull: {
      quantity: UnitConstants.QUANTITY.FORCE,
      validator: TERMS.REQUIRED_AT_LEAST_ZERO,
    },
    pressureSheathOuterDiameter: {
      quantity: UnitConstants.QUANTITY.LENGTH,
      validator: TERMS.REQUIRED_AT_LEAST_ZERO,
    },
    externalSheathOuterDiameter: {
      quantity: UnitConstants.QUANTITY.LENGTH,
      validator: TERMS.REQUIRED_AT_LEAST_ZERO,
    },
    stressUnderDesignPressure: {
      quantity: UnitConstants.QUANTITY.ELASTIC_MODULE,
      validator: TERMS.REQUIRED_SCI_NOTATION_AT_LEAST_ZERO,
    },
    designPressure: {
      quantity: UnitConstants.QUANTITY.ELASTIC_MODULE,
      validator: TERMS.REQUIRED_SCI_NOTATION_AT_LEAST_ZERO,
    },
    minimumYieldStress: {
      quantity: UnitConstants.QUANTITY.ELASTIC_MODULE,
      validator: TERMS.REQUIRED_SCI_NOTATION_AT_LEAST_ZERO,
    },
  };
}
